import { render } from "./permanence_registro.vue?vue&type=template&id=f95fcc0c"
import script from "./permanence_registro.vue?vue&type=script&lang=js"
export * from "./permanence_registro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__